import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HomesFacade } from '@library/store/homes/homes.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import { Enums } from 'constants/Enums.constant';
import { map, withLatestFrom } from 'rxjs';

interface IndoorAirQuality {
  label: string,
  color: string,
  backgroundColor: string,
}

const GOOD: IndoorAirQuality = {
  label: 'station-app.__GAUGE_AIRNOW_1',
  color: 'var(--green-confirmation)',
  backgroundColor: 'var(--green-confirmation-transparent)',
};

const FAIR: IndoorAirQuality = {
  label: 'station-app.__GAUGE_AIRNOW_2',
  color: 'var(--yellow)',
  backgroundColor: 'var(--yellow-transparent)',
};

const POOR: IndoorAirQuality = {
  label: 'station-app.__GAUGE_AUSTRALIA_4',
  color: 'var(--red-alert)',
  backgroundColor: 'var(--red-alert-transparent)',
};

@Component({
  selector: 'app-indoor-air-quality',
  templateUrl: './indoor-air-quality.component.html',
  styleUrls: ['./indoor-air-quality.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndoorAirQualityComponent {

  display$ = this.sidebarRoomService.roomModules$.pipe(
    withLatestFrom(this.homesFacade.currentHome$),
    map(([modules, home]) => {
      return home.mode !== 'favorite' && (modules.map(m => m.type).includes(Enums.ModuleType.NAMAIN) || modules.map(m => m.type).includes(Enums.ModuleType.NAMODULE4));
    }),
  );

  indoorAirQuality$ = this.sidebarRoomService.roomModules$.pipe(
    map(modules => modules.find(m => m.type === Enums.ModuleType.NAMAIN || m.type === Enums.ModuleType.NAMODULE4)),
    isDefined(),
    map(module => {
      if (typeof module.CO2 === 'undefined') {
        return false;
      }
      else if (module.CO2 < 1150) {
        return GOOD;
      }
      else if (module.CO2 >= 1150 && module.CO2 <= 1400) {
        return FAIR;
      }
      else {
        return POOR;
      }
    }),
  );

  constructor(
    private sidebarRoomService: SidebarRoomService,
    private homesFacade: HomesFacade,
  ) { }

}
